<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "SubDefaultContainer",
  data() {
    return {};
  },
  methods: {
    init() {}
  },
  watch: {},
  beforeMount: function() {
  },
  mounted: function() {
    this.init();
  },
  computed: {}
};
</script>

<style scoped>
</style>

